// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SectionH_TheComp__krXfu"};